module.exports = __webpack_public_path__ + "img/aeiou_1.5f91ac82.png";